import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;
const API_KEY = 'BT001-REACH-TRCKS';

// Email Template DTOs
export class CreateEmailTemplateDto {
  constructor({ templateName, subject, body }) {
    this.templateName = templateName;
    this.subject = subject;
    this.body = body;
  }
}

export class UpdateEmailTemplateDto {
  constructor({ templateName, subject, body }) {
    this.templateName = templateName;
    this.subject = subject;
    this.body = body;
  }
}

export class EmailTemplateDto {
  constructor({ id, templateName, subject, body, createdAt, updatedAt }) {
    this.id = id;
    this.templateName = templateName;
    this.subject = subject;
    this.body = body;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}


// SMS Template DTOs
export class CreateSmsTemplateDto {
  constructor({ templateName, message }) {
    this.templateName = templateName;
    this.message = message;
  }
}

export class UpdateSmsTemplateDto {
  constructor({ templateName, message }) {
    this.templateName = templateName;
    this.message = message;
  }
}

export class SmsTemplateDto {
  constructor({ id, templateName, message, createdAt, updatedAt }) {
    this.id = id;
    this.templateName = templateName;
    this.message = message;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}


export async function getAllEmailTemplates(apiKey = API_KEY) {
  try {
    const response = await axios.get(`${API_BASE}/templates/email`, {
      headers: {
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch templates');
  }
}

export async function getAllEmailTemplatesDropdown(apiKey = API_KEY) {
  try {
    const response = await axios.get(`${API_BASE}/templates/email/dropdown`, {
      headers: {
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch templates dropdown');
  }
}

export async function getEmailTemplate(id, apiKey = API_KEY) {
  try {
    const response = await axios.get(`${API_BASE}/templates/email/${id}`, {
      headers: {
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch template');
  }
}

export async function createEmailTemplate(dto, apiKey = API_KEY) {
  try {
    const response = await axios.post(`${API_BASE}/templates/email`, dto, {
      headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to create template');
  }
}

export async function updateEmailTemplate(id, dto, apiKey = API_KEY) {
  try {
    const response = await axios.put(`${API_BASE}/templates/email/${id}`, dto, {
      headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to update template');
  }
}

export async function deleteEmailTemplate(id, apiKey = API_KEY) {
  try {
    await axios.delete(`${API_BASE}/templates/email/${id}`, {
      headers: {
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return true;
  } catch (error) {
    throw new Error('Failed to delete template');
  }
} 



export async function getAllSmsTemplates(apiKey = API_KEY) {
  try {
    const response = await axios.get(`${API_BASE}/templates/sms`, {
      headers: {
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch templates');
  }
}

export async function getAllSmsTemplatesDropdown(apiKey = API_KEY) {
  try {
    const response = await axios.get(`${API_BASE}/templates/sms/dropdown`, {
      headers: {
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch templates dropdown');
  }
}

export async function getSmsTemplate(id, apiKey = API_KEY) {
  try {
    const response = await axios.get(`${API_BASE}/templates/sms/${id}`, {
      headers: {
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch template');
  }
}

export async function createSmsTemplate(dto, apiKey = API_KEY) {
  try {
    const response = await axios.post(`${API_BASE}/templates/sms`, dto, {
      headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to create template');
  }
}

export async function updateSmsTemplate(id, dto, apiKey = API_KEY) {
  try {
    const response = await axios.put(`${API_BASE}/templates/sms/${id}`, dto, {
      headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to update template');
  }
}

export async function deleteSmsTemplate(id, apiKey = API_KEY) {
  try {
    await axios.delete(`${API_BASE}/templates/sms/${id}`, {
      headers: {
        'accept': '*/*',
        'X-API-Key': API_KEY,
      },
    });
    return true;
  } catch (error) {
    throw new Error('Failed to delete template');
  }
} 